exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* 消除小三角 */\n.el-popper[x-placement^=bottom] .popper__arrow{\n  border: none;\n}\n.el-popper[x-placement^=bottom] .popper__arrow::after{\n  border: none;\n}\n.el-dropdown {\n  min-width: 120px;\n  text-align: right;\n}\n.el-dropdown-menu {\n  width: 164px !important;\n  -webkit-box-sizing: border-box !important;\n  box-sizing: border-box !important;\n  position: fixed !important;\n  top: 46px !important;\n  right: 200px !important;\n  padding: 4px !important;\n  text-align: center !important;\n}\n.el-dropdown-item {\n  height: 40px !important;\n  line-height: 40px !important;\n}\n", ""]);

// exports
